import { render, staticRenderFns } from "./SysBigdataForm.vue?vue&type=template&id=d1704b7e&"
import script from "./SysBigdataForm.vue?vue&type=script&lang=js&"
export * from "./SysBigdataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports